//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["search_info"],
  data() {
    return {
      hide_input1: true
    };
  },
  methods: {
    onInputChange () {
      console.log('inputChange', this.search_info.value)
      this.$emit('inputChange', this.search_info.value)
    }
  }
};
